// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./EventCard.MoreDetails.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, TextPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      DLHcJ4h7hK: {
        none: {
          text: "More Details",
          htmlElement: "span",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "dark",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "dark",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "dark",
  },
];

export const MoreDetailsContext = createContext(null);

function MoreDetails(_props) {
  const defaults = useContext(MoreDetailsContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="WkzSNvUbVf"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "WkzSNvUbVf",
        scope: "4ajky2ZWbG",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <TextPrimitive
          id={"Text_DLHcJ4h7hK"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_4ajky2ZWbG_DLHcJ4h7hK"
          }
          key={"DLHcJ4h7hK"}
          text={getStyle("DLHcJ4h7hK", "text")}
          element={getStyle("DLHcJ4h7hK", "htmlElement")}
        />
      )}
    </RootPrimitive>
  );
}

MoreDetails.__variants = [
  {
    name: "dark",
    type: "variant",
  },
];

export default MoreDetails;
